export default "__VITE_ASSET__BgKJThuu__"